import { IAccount, IService } from 'interfaces/IUser';
import SERVICE_TYPE_ID from 'constants/ServiceTypeId';
import { getAccessByRole } from './getAccessbyRole';

export const mapServicesWithAccounts = (servicesData: IService[], accountsData: IAccount[]) => {
  const services = servicesData?.filter(({ serviceTypeId }) => (
    serviceTypeId === SERVICE_TYPE_ID
  )).map((item) => {
    const account = accountsData.find(({ id }) => id === +item.accountId);
    if (account) {
      return ({
        ...item,
        logo: account.logo,
        accountName: account.name,
        accountShortName: account.shortName,
        isAdmin: account.isAdmin,
        isOwner: account.isOwner,
        access: getAccessByRole(item.role),
      });
    }
    return item;
  });

  return services;
};
